import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {Observable} from "rxjs";
import {ModalService} from "../../../../../services/ui/modal.service";
import {SubscriptionLike as ISubscription} from "rxjs/internal/types";
import {CacheService} from "../../../../../services/sys/cache.service";

@Component({
    selector: 'efast-modal-error',
    templateUrl: 'efast-modal-error.component.html',
    styleUrls: ['./efast-modal-error.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EfastModalErrorComponent implements OnInit {
    modalSubscription: ISubscription | null = null;
    show: boolean = false;
    msg: string = "";
    btnLabel: string = "";

    constructor(private el: ElementRef,
                private modalService: ModalService,
                private cacheService: CacheService) {
        this.modalSubscription = this.modalService.modalErrorServiceSubject.subscribe(data => this.modalChangeEvent(data));
    }
    private modalChangeEvent(data) {
        if (this.modalService.isShow()) {
            this.show = true;
            this.el.nativeElement.classList.add('sshow')
        }
        else {
            this.show = false;
            this.el.nativeElement.classList.add('hhidden')
        }

    }
    ngOnInit() {

        this.msg = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONModalErrorMsg');
        this.btnLabel = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONModalErrorBtnLbl');
    }
    close() {
        this.modalService.setShow(false);
        this.show = false;
        this.el.nativeElement.classList.remove('sshow')
        this.el.nativeElement.classList.add('hhidden')
    }
}
